import {
  DeletionStatus,
  DeletionTrigger,
  SubscriptionStatus,
} from "@safetyculture/s12-apis-connect-web/s12/accounts/history/v1/history_pb";

export const deletionStatusDisplayMapping: Record<DeletionStatus, string> = {
  [DeletionStatus.UNSPECIFIED]: "Unspecified",
  [DeletionStatus.NOT_DELETED]: "Not deleted",
  [DeletionStatus.IN_PROGRESS]: "In progress",
  [DeletionStatus.DONE]: "Done",
  [DeletionStatus.FAILED]: "Failed",
  [DeletionStatus.CANCELLED]: "Cancelled",
};

export const deletionTriggerDisplayMapping: Record<DeletionTrigger, string> = {
  [DeletionTrigger.UNSPECIFIED]: "Unspecified",
  [DeletionTrigger.USER_INITIATED]: "User initiated",
  [DeletionTrigger.SUPPORT]: "Support",
  [DeletionTrigger.ABANDONED]: "Abandoned",
};

export const subscriptionStatusDisplayMapping: Record<
  SubscriptionStatus,
  string
> = {
  [SubscriptionStatus.UNSPECIFIED]: "Unspecified",
  [SubscriptionStatus.ACTIVE]: "Active",
  [SubscriptionStatus.CANCELLED]: "Cancelled",
  [SubscriptionStatus.EXPIRED]: "Expired",
  [SubscriptionStatus.TRIAL]: "Trial",
};
